<template>
  <vs-sidebar
    click-not-close
    position-right
    v-model="dialogShow"
    class="items-no-padding mobileTradeCycleSiderBar sidebar-dialog">
    <div class="sidebar-content">

      <div class="customizer-header flex items-center justify-between px-6 sliderbar-header">
        <div class="top-left">
          <span class="dialog-title">
            {{title}}
          </span>
          <!--
v-if="statistics.userStatus !== 0 && statistics.userStatus == 3"
todo 需要判断和传参数
-->
          <start-btn
            :mt-id="+$route.params.mtid"
            @startUsing-success="startUsingSuccess"
          ></start-btn>
        </div>
        <feather-icon icon="XIcon" @click.stop="close" class="cursor-pointer"></feather-icon>
      </div>
      <VuePerfectScrollbar
        class="scroll-area--customizer pt-4 pb-6"
        :settings="settings"
        :key="$vs.rtl"
      >
        <div class="content">
          <trade-cycle-sider-bar
            ref="siderbarinner"
            @current-tradeCycle="currentTradeCycle"
          ></trade-cycle-sider-bar>
        </div>
      </VuePerfectScrollbar>
    </div>
  </vs-sidebar>
</template>

<script>

import startBtn from "@/components/user/details/mamMaster/tradingCycle/startBtn";
import tradeCycleSiderBar from "@/components/user/details/mamMaster/tradingCycle/tradeCycleSiderBar";
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: "mobileTradeCycleSiderBar",
  components: {
    tradeCycleSiderBar,
    VuePerfectScrollbar,
    startBtn,
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      title: this.$t('Trading_cycle'),

      settings: {
        maxScrollbarLength : 60,
        wheelSpeed         : .60,
      },
    }
  },
  methods: {
    close(){
      this.$emit('close')
    },
    currentTradeCycle(currentTradeCycle,statistics){
      this.$emit('current-tradeCycle',currentTradeCycle,statistics);
    },
    startUsingSuccess(){
      this.$emit('startUsing-success');
    }
  },
}
</script>

<style lang="scss">
.mobileTradeCycleSiderBar {
  .content {
  }
  .vericode-form-item {
    margin-bottom: 5px;
  }
}
</style>
<style lang="scss">
.mobileTradeCycleSiderBar {
  .vs-sidebar--items {

  }
  .dititle-title {
    font-weight: 600;
    font-size: 18px;
    color: #5E5873;
  }
  .scroll-area--customizer {
    height: calc(100% - 4rem);
  }
  .top-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .dialog-title {
      margin-right: 20px;
    }
  }

}
</style>
